import routerOptions0 from "/builds/uroweb/uroweb-frontend/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@types+node@20.19.43_@vue+compiler-sfc@3.5.42_cac@6.7_pivmpmidm37bm7taa4wu5dwcxe/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}